import {
    DslNodeWidget,
    executeViewAction,
    http,
    Router,
    RuntimeViewAction,
    SPI,
    subscribeRoute,
    Subscription,
    useMatched,
    ViewActionTarget,
    ViewType,
    ViewWidget,
    Widget
} from '@kunlun/dependencies';
import Comp from './PCNotice.vue';
import {NoticeItem} from "@/mask";

@SPI.ClassFactory(
    ViewWidget.Token({
        widget: 'PCNotice'
    })
)
export default class PCNoticeWidget extends DslNodeWidget {
    public initialize(props) {
        super.initialize(props);
        this.setComponent(Comp);
        return this;
    }

    private routeSubscription!: Subscription;

    @Widget.Reactive()
    newNotice: any = {};
    @Widget.Reactive()
    private moduleStr = '';

    @Widget.Reactive()
    get show() {
        return 'deliAriesCoreMerchant' === this.moduleStr;
    }

    @Widget.Reactive()
    private visible = false;

    protected router!: Router;

    protected async mounted() {
        this.routeSubscription = subscribeRoute(
            (url) => {
                const {matched} = useMatched();
                const {segmentParams} = matched;

                // 经销工作台
                if (segmentParams?.page?.module === 'deliAriesCoreMerchant') {
                    this.visible = true;
                } else {
                    this.visible = false;
                }
            },
            {
                distinct: true
            }
        );
        this.queryNotice().then(data => {
            this.newNotice = data;
        }) ;
    }

    protected $$unmounted(): void {
        super.$$unmounted();
        this.routeSubscription?.unsubscribe();
    }


    @Widget.Method()
    async jump(router:string) {

        if(router === "notice")
        {
            executeViewAction(
                {
                    viewType: ViewType.Table,
                    moduleName: 'deliAriesCoreMerchant',
                    model: 'deli.aries.seller.DeliAriesMerchantNotice',
                    name: 'MenuuiMenu9ae90f77adaf45f6a69a0c565f5fe6d3',
                    target: ViewActionTarget.OpenWindow,
                    resModuleName: 'deliAriesCoreMerchant'
                } as RuntimeViewAction,
                undefined,
                undefined,
                undefined
            );
        }
        else{
            executeViewAction(
                {
                    viewType: ViewType.Form,
                    moduleName: 'deliAriesCoreMerchant',
                    model: 'aries.trade.merchant.AriesMerchantSellerTradeRule',
                    name: 'MenuuiMenu0000000000006502',
                    target: ViewActionTarget.Router,
                    resModuleName: 'deliAriesCoreMerchant'
                } as RuntimeViewAction,
                undefined,
                undefined,
                undefined
            );
        }

    }

    @Widget.Method()
    async ignore(id:string) {
        const gql = `
      query {
        deliAriesMerchantNoticeQuery {
          ignore(query: {id: ${this.newNotice.id}}) {
            id
            content 
            title
            publishDate
            isJump
          }
        }
      }
    `;
        const res = await http.query<{ content: NoticeItem[]; total: number }>('deliAriesCoreMerchant', gql);
        const data = res.data.deliAriesMerchantNoticeQuery.ignore;
    }

    async queryNotice() {

        const gql = `
      query {
        deliAriesMerchantNoticeQuery {
          queryNew {
            id
            content 
            title
            publishDate
            isJump
          }
          
        }
      }
    `;
        const res = await http.query<{ content: NoticeItem[]; total: number }>('deliAriesCoreMerchant', gql);
        const data = res.data.deliAriesMerchantNoticeQuery.queryNew;
        return data;
    }
}
